import { useRef as u, useEffect as c } from "react";
import { jsx as d } from "react/jsx-runtime";

function s(e, t) {
  c(function () {
    function n(r) {
      e.current && !e.current.contains(r.target) && t();
    }

    function o(r) {
      r.key === "Escape" && t();
    }

    return document.addEventListener("mousedown", n), document.addEventListener("keydown", o), function () {
      document.removeEventListener("mousedown", n), document.removeEventListener("keydown", o);
    };
  }, [e, t]);
}

var a = function a(_ref) {
  var e = _ref.onBlur,
      t = _ref.children;
  var n = u(null);
  return s(n, e), /* @__PURE__ */d("div", {
    ref: n,
    children: t
  });
};

export { a as BlurDetector };